import store from '@/store'

export default [
  {
    path: '/school-contacts',
    name: 'school-contact',
    meta: { requiresAuth: true },
    component: () => import('@/pages/school-contact/form.vue')
  },
  {
    path: '/school-contacts/:id',
    name: 'school-contact-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/school-contact/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('schoolContact/find', to.params.id)
      next()
    }
  }
]
